(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-manager/assets/javascripts/draw-manager-content.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-manager/assets/javascripts/draw-manager-content.js');
"use strict";


const {
  useEffect
} = React;
const Paper = svs.ui.ReactPaper;
const {
  ScrollAwareTopOverlay
} = svs.components.lbUi.scrollAwareTopOverlay;
const {
  DrawCardLarge,
  DrawCardSmall,
  DrawCardMini
} = svs.components.tipsen.drawCard;
const {
  useCountdownMini
} = svs.components.tipsen.drawManager;
const {
  DrawSelectorTable
} = svs.components.tipsen.drawSelector;
const {
  VisibilityWrapper
} = svs.components.tipsen.visibilityWrapper;
const DrawManagerContent = _ref => {
  let {
    isMediumDevice,
    toggleDrawSelector,
    composedDraws,
    composedCurrentDraw,
    productBranding,
    shouldEnableDrawSelector,
    showBetEventsByDraw,
    toggleBetEventsFunc,
    isDrawSelectorVisible
  } = _ref;
  const DrawCardVariant = isMediumDevice ? DrawCardLarge : DrawCardSmall;
  const drawManagerRef = React.useRef();

  useEffect(() => {
    const element = drawManagerRef.current;
    element === null || element === void 0 ? void 0 : element.addEventListener('tipsenOpenDrawSelector', toggleDrawSelector);
    return () => element === null || element === void 0 ? void 0 : element.removeEventListener('tipsenOpenDrawSelector', toggleDrawSelector);
  }, [toggleDrawSelector]);
  const countdownString = useCountdownMini(composedCurrentDraw.regCloseTime);
  return React.createElement("div", {
    className: "pg_draw_manager",
    ref: drawManagerRef
  }, !isMediumDevice && React.createElement(ScrollAwareTopOverlay, {
    intersectionElementSelector: ".pg_draw_manager__current_draw_card",
    intersectionThreshold: 0.1,
    onTopOverlayWrapperClick: () => composedDraws.length > 1 && toggleDrawSelector(),
    showTopOverlay: Boolean(countdownString)
  }, React.createElement(Paper, {
    branding: "sport",
    className: "elevation-400"
  }, React.createElement(DrawCardMini, {
    branding: productBranding,
    extraMoney: composedCurrentDraw.extraMoney,
    icon: composedCurrentDraw.icon,
    league: composedCurrentDraw.league,
    netSale: composedCurrentDraw.netSale,
    regCloseTime: countdownString ? countdownString : composedCurrentDraw.regCloseTime,
    state: composedCurrentDraw.state,
    title: composedCurrentDraw.title
  }))), React.createElement(Paper, {
    branding: "sport",
    className: "pg_draw_manager__current_draw_card".concat(isDrawSelectorVisible ? ' pg_draw_manager__current_draw_card--hidden' : '')
  }, React.createElement(DrawCardVariant, {
    betEvents: composedCurrentDraw.betEvents,
    branding: productBranding,
    extraMoney: composedCurrentDraw.extraMoney,
    icon: composedCurrentDraw.icon,
    netSale: composedCurrentDraw.netSale,
    onChangeDraw: toggleDrawSelector,
    regCloseTime: composedCurrentDraw.regCloseTime,
    shouldShowChangeDrawButton: shouldEnableDrawSelector,
    state: composedCurrentDraw.state,
    title: composedCurrentDraw.title
  })), shouldEnableDrawSelector && React.createElement(VisibilityWrapper, {
    className: "pg_draw_manager__draw_selector",
    isVisible: isDrawSelectorVisible
  }, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement(DrawSelectorTable, {
    branding: productBranding,
    draws: composedDraws,
    onToggleFunc: toggleDrawSelector,
    selectedDrawNumber: composedCurrentDraw.drawNumber,
    showBetEventsByDraw: showBetEventsByDraw,
    toggleBetEventsFunc: toggleBetEventsFunc
  }))));
};
setGlobal('svs.components.tipsen.drawManager.DrawManagerContent', DrawManagerContent);

 })(window);